import type { ProcessingStep } from '../../types/api';

const STEP_LABELS: Record<string, string> = {
  upload: 'File Upload',
  virus_scan: 'Virus Scan',
  text_extraction: 'Text Extraction',
  embedding_generation: 'Embedding Generation',
  entity_extraction: 'Entity Extraction',
};

interface StepListProps {
  steps: ProcessingStep[];
}

export function StepList({ steps }: StepListProps) {
  return (
    <div className="proc-steps">
      {steps.map((step) => {
        const isDone    = step.status === 'done';
        const isActive  = step.status === 'running';
        const isFailed  = step.status === 'failed';
        const stepClass = isDone ? 'done' : isActive ? 'active' : isFailed ? 'failed' : 'pending';

        const elapsed =
          isDone && step.started_at && step.completed_at
            ? `${Math.round(
                (new Date(step.completed_at).getTime() - new Date(step.started_at).getTime()) / 1000
              )}s`
            : null;

        return (
          <div key={step.step_number} className={`proc-step ${stepClass}`}>
            <div className="step-icon-wrap">
              {isDone && (
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
              )}
              {isActive && <span className="spinner" />}
              {isFailed && (
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              )}
              {!isDone && !isActive && !isFailed && (
                <span style={{ fontSize: '0.75rem', color: 'var(--muted)', fontWeight: 600 }}>{step.step_number}</span>
              )}
            </div>
            <div className="step-body">
              <span className="step-name">{STEP_LABELS[step.step_name] ?? step.step_name}</span>
              {step.error_message && (
                <span className="step-detail" style={{ color: 'var(--fail)' }}>{step.error_message}</span>
              )}
              {elapsed && <span className="step-detail">{elapsed}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
